<div class="rounded w-100 float-left">
  <div class="d-flex justify-content-between align-items-center w-100">
    <div class="customersearch-title mb-0">
      {{ pageTitle$ | async }}
    </div>
    <button class="btn back-btn pl-1 pr-1 pb-1 pt-1 font-lg-size" (mousedown)="goBack()" type="button">
      <i class="fas fa-level-down-alt fa-rotate-90"></i>
    </button>
  </div>
</div>
@if (draftOrder) {
  <form [formGroup]="draftOrderEditForm">
    <fieldset [disabled]="isLoading$ | async">
      <div class="col-md-12 float-left customersearch-forms mt-3 login-forms p-0">
        @if (hasLineItemErrors()) {
          <div class="text-danger font-size-16 mb-3 col-lg-12 p-2 float-left">
            @for (message of lineItemErrorMessages; track message) {
              <div>
                 {{ message }}
              </div>
            }
          </div>
        }
        @if (checkisECCAvailablele()) {
          <div class="text-danger font-size-16 mb-3 col-lg-12 p-2 float-left">
            @if (!isECCAvailable) {
              <div>
                {{ integrationMessage }}
              </div>
            }
          </div>
        }
        @if (isPartialReorder) {
          <div class="text-danger font-size-16 mb-3 col-lg-12 p-2 float-left">
            {{ 'CartCommon.messages.partialReorderSkippedItems' | cxTranslate }}
          </div>
        }
        <div class="col-lg-12 p-0 float-left">
          <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3">
            <input type="text" disabled [value]="draftOrder?.divisionName ?? ''" class="form-control w-100"
              [placeholder]="'CartCommon.label.atgDivision' | cxTranslate" />
            <span class="highlight"></span>
            <label for="number" class="text-muted">{{ 'CartCommon.label.atgDivision' | cxTranslate }}</label>
          </div>
          <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3">
            <input disabled type="text" class="form-control w-100" [value]="draftOrder?.accountNumber"
              [placeholder]="'CartCommon.label.customerAccount' | cxTranslate" />
            <span class="highlight"></span>
            <label for="name" class="text-muted">{{ 'CartCommon.label.customerAccount' | cxTranslate }}
              <span class="text-danger font-size-18 float-right ml-2">*</span></label>
            </div>
            <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3">
              <input type="text" class="form-control w-100" disabled [value]="draftOrder?.accountName"
                [placeholder]="'CartCommon.label.customerName' | cxTranslate" />
              <span class="highlight"></span>
              <label for="status" class="text-muted">{{ 'CartCommon.label.customerName' | cxTranslate }}</label>
            </div>
            <!-- <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3">
              <input type="text" disabled [value]="draftOrder?.code" class="form-control w-100"
                [placeholder]="'CartCommon.label.number' | cxTranslate" />
              <span class="highlight"></span>
              <label for="number" class="text-muted">{{ 'CartCommon.label.number' | cxTranslate }}</label>
            </div> -->
            <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3">
              <input (keyup)="detectChange()" type="text" class="form-control w-100"
                [placeholder]="'CartCommon.label.name' | cxTranslate" formControlName="name" />
              <span class="highlight"></span>
              <label for="name" class="text-muted">{{ 'CartCommon.label.name' | cxTranslate }}
                <span class="text-danger font-size-18 float-right ml-2">*</span></label>
                <cx-form-errors [control]="draftOrderEditForm.get('name')"></cx-form-errors>
              </div>
              <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3">
                <input type="text" class="form-control w-100" disabled [value]="draftOrder?.cartStatus"
                  [placeholder]="'CartCommon.label.status' | cxTranslate" />
                <span class="highlight"></span>
                <label for="status" class="text-muted">{{ 'CartCommon.label.status' | cxTranslate }}</label>
              </div>
              <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-4 valid-to p-res-0 position-relative">
                <input type="text" class="form-control w-100" [placeholder]="'CartCommon.label.createdBy' | cxTranslate"
                  disabled [value]="draftOrder?.createdBy" />
                <span class="highlight"></span>
                <label for="createdBy" class="text-muted m-0">{{ 'CartCommon.label.createdBy' | cxTranslate }}</label>
              </div>
            </div>
            <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-4 valid-to p-res-0 position-relative">
              <input type="text" class="form-control w-100"
                [placeholder]="'CartCommon.label.createdDate' | cxTranslate" disabled
                [value]="knBrDateHelper.formatDisplayDate(draftOrder?.creationDate)" />
              <span class="highlight"></span>
              <label for="createdOn" class="text-muted m-0">{{ 'CartCommon.label.createdOn' | cxTranslate }}</label>
            </div>
            <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-4 valid-to p-res-0 position-relative">
              <input type="text" class="form-control w-100"
                [placeholder]="'CartCommon.label.lastUpdatedDate' | cxTranslate" disabled
                [value]="knBrDateHelper.formatDisplayDate(draftOrder?.lastUpdatedDate)" />
              <span class="highlight"></span>
              <label for="lastUpdatedDate" class="text-muted m-0">{{
                'CartCommon.label.lastUpdatedDate' | cxTranslate
              }}</label>
            </div>
            <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 valid-to p-res-0 position-relative">
              <label for="requestedDeliveryDate" class="text-muted m-0">{{
                'CartCommon.label.requestedDeliveryDate' | cxTranslate
              }}<span class="text-danger font-size-18 float-right ml-2">*</span></label>
              <div class="input-group">
                <input class="form-control w-100 cursor-pointer" [placeholder]="knBrDateHelper.displayDateFormat" name="rdd"
                  ngbDatepicker #rdd="ngbDatepicker" formControlName="requestedDeliveryDate" (blur)="detectChange()"
                  (dateSelect)="detectChange()" [minDate]="minDate" [markDisabled]="isWeekendDate"
                  [class.border-danger]="draftOrderEditForm.get('requestedDeliveryDate').invalid && draftOrderEditForm.get('requestedDeliveryDate').touched" />
                <div class="input-group-append">
                  <button class="btn btn calendar p-0 h-auto w-auto" container="body" (click)="rdd.toggle()"
                    type="button">
                    <i class="far fa-calendar-alt color-font"></i>
                  </button>
                </div>
              </div>
              <ng-container *ngIf="draftOrderEditForm.get('requestedDeliveryDate') as rddControl">
                <div *ngIf="rddControl.invalid && rddControl.touched" class="text-danger font-size-14 mt-1">
                  <!-- ngb-datepicker's own minDate check also fires (as a generic 'ngbDate' error) whenever
                       the selected date is before today, the same condition pastDate/weekend cover with a
                       clearer message, so only fall back to it when nothing more specific applies. -->
                  <div *ngIf="rddControl.errors?.['required']">{{ 'formErrors.required' | cxTranslate }}</div>
                  <div *ngIf="!rddControl.errors?.['required'] && rddControl.errors?.['pastDate']">{{ 'formErrors.pastDate' | cxTranslate }}</div>
                  <div *ngIf="!rddControl.errors?.['required'] && !rddControl.errors?.['pastDate'] && rddControl.errors?.['weekend']">{{ 'formErrors.weekend' | cxTranslate }}</div>
                  <div *ngIf="!rddControl.errors?.['required'] && !rddControl.errors?.['pastDate'] && !rddControl.errors?.['weekend'] && rddControl.errors?.['ngbDate']">{{ 'formErrors.ngbDate' | cxTranslate }}</div>
                </div>
              </ng-container>
            </div>
            <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3">
              <input type="text" class="form-control w-100" maxlength="25" knBrRestrictPOChars
                [placeholder]="'CartCommon.label.customerPO' | cxTranslate" formControlName="purchaseOrderNumber"
                     (keyup)="detectChange()"
                     [class.border-danger]="draftOrderEditForm.get('purchaseOrderNumber').invalid && (draftOrderEditForm.get('purchaseOrderNumber').touched || draftOrderEditForm.get('purchaseOrderNumber').dirty) || !isCustomerPOValid" />
              <span class="highlight"></span>
              <label for="customerPO" class="text-muted">{{ 'CartCommon.label.customerPO' | cxTranslate }}
                <span class="text-danger font-size-18 float-right ml-2">*</span></label>
                <div *ngIf="draftOrderEditForm.get('purchaseOrderNumber').invalid && (draftOrderEditForm.get('purchaseOrderNumber').touched || draftOrderEditForm.get('purchaseOrderNumber').dirty)" class="text-danger font-size-14 mt-1">
                  <div *ngIf="draftOrderEditForm.get('purchaseOrderNumber').errors?.['required']">{{ 'formErrors.required' | cxTranslate }}</div>
                  <div *ngIf="draftOrderEditForm.get('purchaseOrderNumber').errors?.['maxlength']">{{ 'CartCommon.validation.purchaseOrderNumber.maxlength' | cxTranslate }}</div>
                  <div *ngIf="draftOrderEditForm.get('purchaseOrderNumber').errors?.['pattern']">{{ 'CartCommon.validation.purchaseOrderNumber.pattern' | cxTranslate }}</div>
                </div>
                @if (!isCustomerPOValid) {
                  <div class="text-danger font-size-14 mt-1">
                    {{ 'CartCommon.validation.duplicatePONumber' | cxTranslate }}
                  </div>
                }
              </div>
              <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3" *ngIf="draftOrder?.orderType === 'ZFD'">
                <ng-select formControlName="orderReasonCode" [items]="costCenters"
                  [placeholder]="'CartCommon.label.costCentre' | cxTranslate"
                  [searchable]="true" [clearable]="true"
                  bindLabel="name" bindValue="code"
                  (change)="detectChange()">
                </ng-select>
                <span class="highlight"></span>
                <label for="costCentre" class="text-muted">{{ 'CartCommon.label.costCentre' | cxTranslate }}
                  <span class="text-danger font-size-18 float-right ml-2">*</span></label>
                <cx-form-errors [control]="draftOrderEditForm.get('orderReasonCode')"></cx-form-errors>
              </div>
              <div class="col-lg-12 p-0 float-left mb-3">
                <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3 position-relative" *ngIf="showPromoCode">
                    <input (keyup)="detectChange(); onPromoCodeInput()"
                        type="text" class="form-control w-100"
                        [placeholder]="'CartCommon.label.promoCode' | cxTranslate" formControlName="promoCode"
                        [class.border-danger]="(draftOrderEditForm.get('promoCode').invalid && draftOrderEditForm.get('promoCode').touched) || sapMessageErrors['promoCode']" />
                    <span class="highlight"></span>
                    <label for="promoCode" class="text-muted">{{ 'CartCommon.label.promoCode' | cxTranslate }}</label>
                    @if (draftOrderEditForm.get('promoCode').value && !isPromoCodeToastDismissed) {
                      <div class="promo-code-toast">
                        <button type="button" class="promo-code-toast__close" (click)="dismissPromoCodeToast()" [attr.aria-label]="'toolTip.close' | cxTranslate">
                          <i class="fas fa-times"></i>
                        </button>
                        <div class="promo-code-toast__body">
                          <div class="promo-code-toast__subtitle">{{ 'CartCommon.toolTip.promoCode' | cxTranslate }}</div>
                        </div>
                      </div>
                    }
                    @if (sapMessageErrors['promoCode']) {
                      <div class="text-danger font-size-14 mt-1">
                        {{ sapMessageErrors['promoCode'] }}
                      </div>
                    }
                    <div *ngIf="!sapMessageErrors['promoCode'] || draftOrderEditForm.get('promoCode').invalid && draftOrderEditForm.get('promoCode').touched" class="text-danger font-size-14 mt-1">
                        <div *ngIf="draftOrderEditForm.get('promoCode').errors?.['maxlength']">{{ 'CartCommon.validation.promoCode.maxlength' | cxTranslate }}</div>
                        <div *ngIf="draftOrderEditForm.get('promoCode').errors?.['pattern']">{{ 'CartCommon.validation.promoCode.pattern' | cxTranslate }}</div>
                    </div>
                </div>
                <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3" *ngIf="showSalesDeal">
                    <input (keyup)="detectChange()" type="text" class="form-control w-100"
                        [placeholder]="'CartCommon.label.salesDeal' | cxTranslate" formControlName="salesDeal"
                        [class.border-danger]="(draftOrderEditForm.get('salesDeal').invalid && draftOrderEditForm.get('salesDeal').touched) || sapMessageErrors['salesDeal']" />
                    <span class="highlight"></span>
                    <label for="salesDeal" class="text-muted">{{ 'CartCommon.label.salesDeal' | cxTranslate }}</label>
                    @if (sapMessageErrors['salesDeal']) {
                      <div class="text-danger font-size-14 mt-1">
                        {{ sapMessageErrors['salesDeal'] }}
                      </div>
                    }
                    <div *ngIf="!sapMessageErrors['salesDeal'] || draftOrderEditForm.get('salesDeal').invalid && draftOrderEditForm.get('salesDeal').touched" class="text-danger font-size-14 mt-1">
                        <div *ngIf="draftOrderEditForm.get('salesDeal').errors?.['maxlength']">{{ 'CartCommon.validation.salesDeal.maxlength' | cxTranslate }}</div>
                        <div *ngIf="draftOrderEditForm.get('salesDeal').errors?.['pattern']">{{ 'CartCommon.validation.salesDeal.pattern' | cxTranslate }}</div>
                    </div>
                </div>
                <div class="form-group mt-3 col-lg-2 pl-0 float-left mb-3 position-relative" *ngIf="showQuoteNumber">
                    <input (keyup)="detectChange(); onQuoteInput()" type="text" class="form-control w-100"
                        [placeholder]="'CartCommon.label.quote' | cxTranslate" formControlName="quote"
                        [class.border-danger]="(draftOrderEditForm.get('quote').invalid && draftOrderEditForm.get('quote').touched) || sapMessageErrors['quote']" />
                    <span class="highlight"></span>
                    <label for="quote" class="text-muted">{{ 'CartCommon.label.quote' | cxTranslate }}</label>
                    @if (draftOrderEditForm.get('quote').value && !isQuoteToastDismissed) {
                      <div class="promo-code-toast">
                        <button type="button" class="promo-code-toast__close" (click)="dismissQuoteToast()" [attr.aria-label]="'toolTip.close' | cxTranslate">
                          <i class="fas fa-times"></i>
                        </button>
                        <div class="promo-code-toast__body">
                          <div class="promo-code-toast__subtitle">{{ 'CartCommon.toolTip.quote' | cxTranslate }}</div>
                        </div>
                      </div>
                    }
                    @if (sapMessageErrors['quote']) {
                      <div class="text-danger font-size-14 mt-1">
                        {{ sapMessageErrors['quote'] }}
                      </div>
                    }
                    <div *ngIf="!sapMessageErrors['quote'] || draftOrderEditForm.get('quote').invalid && draftOrderEditForm.get('quote').touched" class="text-danger font-size-14 mt-1">
                        <div *ngIf="draftOrderEditForm.get('quote').errors?.['maxlength']">{{ 'CartCommon.validation.quote.maxlength' | cxTranslate }}</div>
                        <div *ngIf="draftOrderEditForm.get('quote').errors?.['pattern']">{{ 'CartCommon.validation.quote.pattern' | cxTranslate }}</div>
                    </div>
                </div>
                <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3" *ngIf="showStoreNumber">
                    <input (keyup)="detectChange()" type="text" class="form-control w-100" maxlength="20"
                        [placeholder]="'CartCommon.label.storeNumber' | cxTranslate" formControlName="storeNumber"
                        [class.border-danger]="draftOrderEditForm.get('storeNumber').invalid && draftOrderEditForm.get('storeNumber').touched" />
                    <span class="highlight"></span>
                    <label for="storeNumber" class="text-muted">{{ 'CartCommon.label.storeNumber' | cxTranslate }}</label>
                    <cx-form-errors [control]="draftOrderEditForm.get('storeNumber')"></cx-form-errors>
                </div>
                <div class="form-group head-notes mt-3 col-lg-3 pl-0 float-left mb-3">
                  <label for="exampleFormControlTextarea1">{{ 'CartCommon.label.specialInstructions' | cxTranslate
                  }}</label>
                  <textarea class="form-control w-100" id="exampleFormControlTextarea1" rows="2" maxlength="255"
                    [placeholder]="'CartCommon.label.specialInstructions' | cxTranslate"
                  formControlName="headerComments" (keyup)="detectChange()"></textarea>
                </div>
                
                @if (statuses$ | async; as statuses) {
                  @if (statuses && statuses.length && draftOrder && draftOrder.entries?.length && !draftOrder.checkoutReady) {
                    <div class="form-group head-notes mt-3 col-lg-2 pl-0 float-left mb-3"
                      >
                      <ng-select class="" formControlName="draftOrderStatus" [items]="statuses$ | async"
                        [placeholder]="'label.actions' | cxTranslate" [searchable]="false" [clearable]="false"
                        bindLabel="Text" bindValue="Key" [readonly]="!draftOrderEditForm.valid">
                      </ng-select>
                      <span class="highlight"></span>
                      <label for="actions" class="text-muted">{{ 'label.actions' | cxTranslate }}</label>
                    </div>
                  }
                  @if (statuses && statuses.length && draftOrder && draftOrder.entries?.length && !draftOrder.checkoutReady) {
                    <div class="form-group head-notes mt-3 col-lg-2 pl-0 float-left mb-3"
                      >
                      <button type="button" class="btn btn-primary" (click)="detectChange()"
                        [disabled]="!draftOrderEditForm.valid">
                        {{ 'quoteCommon.label.go' | cxTranslate }}
                      </button>
                    </div>
                  }
                }
              </div>
              <div class="col-lg-12 p-0 float-left mb-3">
                <div class="remember-me float-left mt-4 d-flex justify-content-start p-2 mr-4" *ngIf="!(hideOrderActions$ | async)">
                  <div class="form-check custom-checkbox m-0 pl-3">
                    <input type="checkbox" class="custom-control-input" id="defaultUnchecked"
                      formControlName="shipComplete" (change)="detectChange()" />
                    <label class="custom-control-label color-font" for="defaultUnchecked">{{
                      'CartCommon.label.shipComplete' | cxTranslate
                    }}</label>
                  </div>
                </div>
                @if (!(isCartOwnerCurrentUser$ | async)) {
                  <div
                    class="col-md-4 float-left text-left p-0 customer-search-btns d-flex align-items-center m-res-bottom">
                    @if (draftOrder && draftOrder.checkoutReady && !(hideOrderActions$ | async)) {
                      <button type="button"
                        class="btn btn-primary col-md-6 mt-3" [disabled]="initialLoad || !draftOrderEditForm.valid || (hasUnsavedItemChanges$ | async) || hasDisabledProductTypeEntries || hasBlockedDistChainEntries || !isCustomerPOValid || hasSapErrors || hasZeroNetPriceEntry || hasCartLoadError || (hasNoOrderPlacementRole$ | async)"
                        (click)="navigate('/checkout')">
                        {{ 'CartCommon.label.checkout' | cxTranslate }}
                      </button>
                    }
                    @if (draftOrder && draftOrder.checkoutReady && !(hidePricing$ | async)) {
                      <button type="button"
                        class="btn btn-primary col-md-6 mt-3 ml-3" [disabled]="!draftOrderEditForm.valid || (!initialLoad && !(hasUnsavedItemChanges$ | async)) || hasDisabledProductTypeEntries"
                        (click)="updateCart()">
                        {{ 'CartCommon.label.update' | cxTranslate }}
                      </button>
                    }
                  </div>
                }
              </div>
              <div class="col-lg-12 p-0 float-left">
                <div class="col-lg-3 float-left pl-1 color-font font-size-17 font-text-600">
                  <label for="totalItems" class="float-left font-text-600 mr-2">{{ 'CartCommon.label.totalItems' |
                    cxTranslate }}
                  </label>
                  {{ draftOrder?.totalItems }}
                </div>
                <div class="col-lg-3 float-left pl-1 color-font font-size-17 font-text-600">
                  <label for="totalQuantity" class="float-left font-text-600 mr-2">{{ 'CartCommon.label.totalQuantity'
                    | cxTranslate }}
                  </label>
                  {{ draftOrder?.totalUnitCount }}
                </div>
                <div class="col-lg-3 float-left pl-1 color-font font-size-17 font-text-600" *ngIf="!(hidePricing$ | async)">
                  <label for="totalPrice" class="float-left font-text-600 mr-2">{{ 'CartCommon.label.totalPrice' |
                    cxTranslate }}
                  </label>
                  {{ draftOrder?.totalPrice?.formattedValue }}
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      }
